export const FormatsData: {[k: string]: ModdedSpeciesFormatsData} = {
	bulbasaur: {
		tier: "LC",
	},
	ivysaur: {
		tier: "NFE",
	},
	venusaur: {
		randomBattleMoves: ["curse", "earthquake", "hiddenpowerrock", "leechseed", "sleeppowder", "sludgebomb", "swordsdance", "synthesis"],
		tier: "UUBL",
	},
	charmander: {
		tier: "LC",
	},
	charmeleon: {
		tier: "NFE",
	},
	charizard: {
		randomBattleMoves: ["bellydrum", "dragondance", "earthquake", "fireblast", "hiddenpowerflying", "substitute"],
		tier: "OU",
	},
	squirtle: {
		tier: "LC",
	},
	wartortle: {
		tier: "NFE",
	},
	blastoise: {
		randomBattleMoves: ["earthquake", "icebeam", "mirrorcoat", "rest", "roar", "sleeptalk", "surf", "toxic"],
		tier: "UU",
	},
	caterpie: {
		tier: "LC",
	},
	metapod: {
		tier: "NFE",
	},
	butterfree: {
		randomBattleMoves: ["gigadrain", "hiddenpowerfire", "morningsun", "psychic", "sleeppowder", "stunspore", "toxic"],
		tier: "PU",
	},
	weedle: {
		tier: "LC",
	},
	kakuna: {
		tier: "NFE",
	},
	beedrill: {
		randomBattleMoves: ["brickbreak", "doubleedge", "endure", "hiddenpowerbug", "sludgebomb", "swordsdance"],
		tier: "PU",
	},
	pidgey: {
		tier: "LC",
	},
	pidgeotto: {
		tier: "NFE",
	},
	pidgeot: {
		randomBattleMoves: ["aerialace", "hiddenpowerground", "quickattack", "return", "substitute", "toxic"],
		tier: "NU",
	},
	rattata: {
		tier: "LC",
	},
	raticate: {
		randomBattleMoves: ["endeavor", "hiddenpowerground", "quickattack", "return", "reversal", "shadowball", "substitute"],
		tier: "NU",
	},
	spearow: {
		tier: "LC",
	},
	fearow: {
		randomBattleMoves: ["agility", "batonpass", "drillpeck", "hiddenpowerground", "quickattack", "return", "substitute"],
		tier: "UU",
	},
	ekans: {
		tier: "LC",
	},
	arbok: {
		randomBattleMoves: ["doubleedge", "earthquake", "hiddenpowerfire", "rest", "rockslide", "sleeptalk", "sludgebomb"],
		tier: "PU",
	},
	pichu: {
		tier: "LC",
	},
	pikachu: {
		randomBattleMoves: ["hiddenpowerice", "substitute", "surf", "thunderbolt"],
		tier: "NU",
	},
	raichu: {
		randomBattleMoves: ["encore", "focuspunch", "hiddenpowergrass", "hiddenpowerice", "substitute", "surf", "thunderbolt", "thunderwave"],
		tier: "UU",
	},
	sandshrew: {
		tier: "LC",
	},
	sandslash: {
		randomBattleMoves: ["earthquake", "hiddenpowerbug", "rapidspin", "rockslide", "swordsdance", "toxic"],
		tier: "UU",
	},
	nidoranf: {
		tier: "LC",
	},
	nidorina: {
		tier: "NFE",
	},
	nidoqueen: {
		randomBattleMoves: ["earthquake", "fireblast", "icebeam", "shadowball", "sludgebomb", "superpower"],
		tier: "UU",
	},
	nidoranm: {
		tier: "LC",
	},
	nidorino: {
		tier: "NFE",
	},
	nidoking: {
		randomBattleMoves: ["earthquake", "fireblast", "icebeam", "megahorn", "sludgebomb", "substitute", "thunderbolt"],
		tier: "UU",
	},
	cleffa: {
		tier: "LC",
	},
	clefairy: {
		tier: "NFE",
	},
	clefable: {
		randomBattleMoves: ["calmmind", "counter", "icebeam", "return", "shadowball", "softboiled", "thunderbolt", "thunderwave"],
		tier: "UU",
	},
	vulpix: {
		tier: "LC",
	},
	ninetales: {
		randomBattleMoves: ["fireblast", "flamethrower", "hiddenpowergrass", "hypnosis", "substitute", "toxic", "willowisp"],
		tier: "UU",
	},
	igglybuff: {
		tier: "LC",
	},
	jigglypuff: {
		tier: "NFE",
	},
	wigglytuff: {
		randomBattleMoves: ["fireblast", "icebeam", "protect", "return", "thunderbolt", "toxic", "wish"],
		tier: "PU",
	},
	zubat: {
		tier: "LC",
	},
	golbat: {
		tier: "NU",
	},
	crobat: {
		randomBattleMoves: ["aerialace", "haze", "hiddenpowerground", "shadowball", "sludgebomb", "taunt", "toxic"],
		tier: "UUBL",
	},
	oddish: {
		tier: "LC",
	},
	gloom: {
		tier: "NFE",
	},
	vileplume: {
		randomBattleMoves: ["aromatherapy", "hiddenpowerfire", "sleeppowder", "sludgebomb", "solarbeam", "sunnyday", "synthesis"],
		tier: "UU",
	},
	bellossom: {
		randomBattleMoves: ["hiddenpowergrass", "leechseed", "moonlight", "sleeppowder", "sludgebomb", "stunspore"],
		tier: "NU",
	},
	paras: {
		tier: "LC",
	},
	parasect: {
		randomBattleMoves: ["aromatherapy", "gigadrain", "hiddenpowerbug", "return", "spore", "stunspore", "swordsdance"],
		tier: "PU",
	},
	venonat: {
		tier: "LC",
	},
	venomoth: {
		randomBattleMoves: ["batonpass", "hiddenpowerground", "signalbeam", "sleeppowder", "sludgebomb", "substitute"],
		tier: "NU",
	},
	diglett: {
		tier: "NU",
	},
	dugtrio: {
		randomBattleMoves: ["aerialace", "earthquake", "hiddenpowerbug", "rockslide", "substitute"],
		tier: "OU",
	},
	meowth: {
		tier: "LC",
	},
	persian: {
		randomBattleMoves: ["fakeout", "hiddenpowerground", "hypnosis", "irontail", "return", "shadowball", "substitute"],
		tier: "UU",
	},
	psyduck: {
		tier: "LC",
	},
	golduck: {
		randomBattleMoves: ["calmmind", "hiddenpowergrass", "hydropump", "hypnosis", "icebeam", "substitute", "surf"],
		tier: "UU",
	},
	mankey: {
		tier: "LC",
	},
	primeape: {
		randomBattleMoves: ["bulkup", "crosschop", "earthquake", "hiddenpowerghost", "rockslide", "substitute"],
		tier: "UU",
	},
	growlithe: {
		tier: "LC",
	},
	arcanine: {
		randomBattleMoves: ["extremespeed", "fireblast", "flamethrower", "hiddenpowergrass", "rest", "sleeptalk", "toxic"],
		tier: "UU",
	},
	poliwag: {
		tier: "LC",
	},
	poliwhirl: {
		tier: "NFE",
	},
	poliwrath: {
		randomBattleMoves: ["brickbreak", "bulkup", "hiddenpowerghost", "hydropump", "hypnosis", "icebeam", "substitute"],
		tier: "UU",
	},
	politoed: {
		randomBattleMoves: ["counter", "hiddenpowergrass", "hypnosis", "icebeam", "surf", "toxic"],
		tier: "UU",
	},
	abra: {
		tier: "LC",
	},
	kadabra: {
		tier: "UUBL",
	},
	alakazam: {
		randomBattleMoves: ["calmmind", "encore", "firepunch", "icepunch", "psychic", "recover", "substitute"],
		tier: "UUBL",
	},
	machop: {
		tier: "LC",
	},
	machoke: {
		tier: "PUBL",
	},
	machamp: {
		randomBattleMoves: ["bulkup", "crosschop", "earthquake", "hiddenpowerghost", "rest", "rockslide", "sleeptalk"],
		tier: "UUBL",
	},
	bellsprout: {
		tier: "LC",
	},
	weepinbell: {
		tier: "NFE",
	},
	victreebel: {
		randomBattleMoves: ["hiddenpowerfire", "sleeppowder", "sludgebomb", "solarbeam", "sunnyday"],
		tier: "UU",
	},
	tentacool: {
		tier: "LC",
	},
	tentacruel: {
		randomBattleMoves: ["gigadrain", "haze", "hydropump", "icebeam", "rapidspin", "surf", "toxic"],
		tier: "UU",
	},
	geodude: {
		tier: "LC",
	},
	graveler: {
		tier: "NFE",
	},
	golem: {
		randomBattleMoves: ["doubleedge", "earthquake", "explosion", "hiddenpowerbug", "rockslide", "toxic"],
		tier: "UU",
	},
	ponyta: {
		tier: "LC",
	},
	rapidash: {
		randomBattleMoves: ["fireblast", "hiddenpowergrass", "hiddenpowerrock", "substitute", "toxic"],
		tier: "UU",
	},
	slowpoke: {
		tier: "LC",
	},
	slowbro: {
		randomBattleMoves: ["calmmind", "fireblast", "icebeam", "psychic", "rest", "sleeptalk", "surf", "thunderwave"],
		tier: "UUBL",
	},
	slowking: {
		randomBattleMoves: ["calmmind", "flamethrower", "icebeam", "psychic", "rest", "sleeptalk", "surf", "thunderwave"],
		tier: "UU",
	},
	magnemite: {
		tier: "LC",
	},
	magneton: {
		randomBattleMoves: ["hiddenpowergrass", "hiddenpowerice", "rest", "sleeptalk", "thunderbolt", "toxic"],
		tier: "OU",
	},
	farfetchd: {
		randomBattleMoves: ["agility", "batonpass", "hiddenpowerflying", "slash", "swordsdance"],
		tier: "PU",
	},
	doduo: {
		tier: "LC",
	},
	dodrio: {
		randomBattleMoves: ["drillpeck", "flail", "hiddenpowerground", "quickattack", "return", "substitute"],
		tier: "UUBL",
	},
	seel: {
		tier: "LC",
	},
	dewgong: {
		randomBattleMoves: ["encore", "hiddenpowergrass", "icebeam", "rest", "sleeptalk", "surf", "toxic"],
		tier: "NU",
	},
	grimer: {
		tier: "LC",
	},
	muk: {
		randomBattleMoves: ["brickbreak", "curse", "explosion", "fireblast", "hiddenpowerghost", "rest", "sludgebomb"],
		tier: "UU",
	},
	shellder: {
		tier: "LC",
	},
	cloyster: {
		randomBattleMoves: ["explosion", "icebeam", "rapidspin", "spikes", "surf", "toxic"],
		tier: "OU",
	},
	gastly: {
		tier: "LC",
	},
	haunter: {
		tier: "NU",
	},
	gengar: {
		randomBattleMoves: ["destinybond", "explosion", "firepunch", "hypnosis", "icepunch", "substitute", "thunderbolt", "willowisp"],
		tier: "OU",
	},
	onix: {
		tier: "LC",
	},
	steelix: {
		randomBattleMoves: ["doubleedge", "earthquake", "explosion", "hiddenpowerrock", "irontail", "rest", "roar", "toxic"],
		tier: "UUBL",
	},
	drowzee: {
		tier: "LC",
	},
	hypno: {
		randomBattleMoves: ["batonpass", "calmmind", "firepunch", "hypnosis", "protect", "psychic", "toxic", "wish"],
		tier: "UU",
	},
	krabby: {
		tier: "LC",
	},
	kingler: {
		randomBattleMoves: ["doubleedge", "hiddenpowerghost", "hiddenpowerground", "surf", "swordsdance"],
		tier: "PU",
	},
	voltorb: {
		tier: "LC",
	},
	electrode: {
		randomBattleMoves: ["explosion", "hiddenpowergrass", "hiddenpowerice", "substitute", "thunderbolt", "thunderwave", "toxic"],
		tier: "UU",
	},
	exeggcute: {
		tier: "LC",
	},
	exeggutor: {
		randomBattleMoves: ["explosion", "gigadrain", "hiddenpowerfire", "hiddenpowerice", "leechseed", "psychic", "sleeppowder", "solarbeam", "sunnyday"],
		tier: "UUBL",
	},
	cubone: {
		tier: "LC",
	},
	marowak: {
		randomBattleMoves: ["bonemerang", "doubleedge", "earthquake", "rockslide", "swordsdance"],
		tier: "UUBL",
	},
	tyrogue: {
		tier: "LC",
	},
	hitmonlee: {
		randomBattleMoves: ["bulkup", "earthquake", "hiddenpowerghost", "highjumpkick", "machpunch", "rockslide", "substitute"],
		tier: "UU",
	},
	hitmonchan: {
		randomBattleMoves: ["bulkup", "earthquake", "hiddenpowerghost", "machpunch", "rapidspin", "skyuppercut", "toxic"],
		tier: "NU",
	},
	hitmontop: {
		randomBattleMoves: ["bulkup", "earthquake", "hiddenpowerghost", "highjumpkick", "machpunch", "rockslide", "toxic"],
		tier: "UU",
	},
	lickitung: {
		randomBattleMoves: ["counter", "healbell", "protect", "return", "seismictoss", "toxic", "wish"],
		tier: "PU",
	},
	koffing: {
		tier: "LC",
	},
	weezing: {
		randomBattleMoves: ["explosion", "fireblast", "haze", "painsplit", "sludgebomb", "toxic", "willowisp"],
		tier: "UUBL",
	},
	rhyhorn: {
		tier: "LC",
	},
	rhydon: {
		randomBattleMoves: ["doubleedge", "earthquake", "megahorn", "rockslide", "substitute", "swordsdance"],
		tier: "UUBL",
	},
	chansey: {
		tier: "UUBL",
	},
	blissey: {
		randomBattleMoves: ["aromatherapy", "calmmind", "icebeam", "seismictoss", "softboiled", "thunderbolt", "thunderwave", "toxic"],
		tier: "OU",
	},
	tangela: {
		randomBattleMoves: ["hiddenpowergrass", "leechseed", "morningsun", "sleeppowder", "stunspore"],
		tier: "PU",
	},
	kangaskhan: {
		randomBattleMoves: ["earthquake", "fakeout", "focuspunch", "rest", "return", "shadowball", "substitute", "toxic"],
		tier: "UU",
	},
	horsea: {
		tier: "LC",
	},
	seadra: {
		tier: "NFE",
	},
	kingdra: {
		randomBattleMoves: ["hiddenpowergrass", "hydropump", "icebeam", "raindance", "substitute", "surf"],
		tier: "UUBL",
	},
	goldeen: {
		tier: "LC",
	},
	seaking: {
		randomBattleMoves: ["hiddenpowergrass", "hydropump", "icebeam", "megahorn", "raindance"],
		tier: "PU",
	},
	staryu: {
		tier: "LC",
	},
	starmie: {
		randomBattleMoves: ["hydropump", "icebeam", "psychic", "recover", "surf", "thunderbolt"],
		tier: "OU",
	},
	mrmime: {
		randomBattleMoves: ["barrier", "batonpass", "calmmind", "encore", "firepunch", "hypnosis", "psychic", "substitute", "thunderbolt"],
		tier: "UU",
	},
	scyther: {
		randomBattleMoves: ["aerialace", "batonpass", "hiddenpowerground", "hiddenpowerrock", "quickattack", "silverwind", "swordsdance"],
		tier: "UU",
	},
	scizor: {
		randomBattleMoves: ["agility", "batonpass", "hiddenpowerground", "hiddenpowerrock", "morningsun", "silverwind", "steelwing", "swordsdance"],
		tier: "UUBL",
	},
	smoochum: {
		tier: "LC",
	},
	jynx: {
		randomBattleMoves: ["calmmind", "hiddenpowerfire", "icebeam", "lovelykiss", "psychic", "substitute"],
		tier: "UUBL",
	},
	elekid: {
		tier: "LC",
	},
	electabuzz: {
		randomBattleMoves: ["crosschop", "firepunch", "focuspunch", "hiddenpowergrass", "icepunch", "substitute", "thunderbolt"],
		tier: "UU",
	},
	magby: {
		tier: "LC",
	},
	magmar: {
		randomBattleMoves: ["crosschop", "fireblast", "flamethrower", "hiddenpowergrass", "psychic", "substitute", "thunderpunch"],
		tier: "UU",
	},
	pinsir: {
		randomBattleMoves: ["earthquake", "hiddenpowerbug", "return", "rockslide", "swordsdance"],
		tier: "UU",
	},
	tauros: {
		randomBattleMoves: ["doubleedge", "earthquake", "hiddenpowerghost", "hiddenpowerrock", "return"],
		tier: "UUBL",
	},
	magikarp: {
		tier: "LC",
	},
	gyarados: {
		randomBattleMoves: ["doubleedge", "dragondance", "earthquake", "hiddenpowerflying", "hydropump", "taunt"],
		tier: "OU",
	},
	lapras: {
		randomBattleMoves: ["healbell", "icebeam", "rest", "sleeptalk", "surf", "thunderbolt", "toxic"],
		tier: "UUBL",
	},
	ditto: {
		randomBattleMoves: ["transform"],
		tier: "PU",
	},
	eevee: {
		tier: "LC",
	},
	vaporeon: {
		randomBattleMoves: ["icebeam", "protect", "surf", "toxic", "wish"],
		tier: "UUBL",
	},
	jolteon: {
		randomBattleMoves: ["batonpass", "hiddenpowerice", "substitute", "thunderbolt", "toxic", "wish"],
		tier: "OU",
	},
	flareon: {
		randomBattleMoves: ["doubleedge", "fireblast", "hiddenpowergrass", "protect", "shadowball", "toxic", "wish"],
		tier: "NU",
	},
	espeon: {
		randomBattleMoves: ["batonpass", "calmmind", "hiddenpowerfire", "morningsun", "psychic", "reflect"],
		tier: "UUBL",
	},
	umbreon: {
		randomBattleMoves: ["batonpass", "hiddenpowerdark", "meanlook", "protect", "toxic", "wish"],
		tier: "UUBL",
	},
	porygon: {
		tier: "LC",
	},
	porygon2: {
		randomBattleMoves: ["icebeam", "recover", "return", "thunderbolt", "thunderwave", "toxic"],
		tier: "UUBL",
	},
	omanyte: {
		tier: "LC",
	},
	omastar: {
		randomBattleMoves: ["hiddenpowergrass", "hydropump", "icebeam", "raindance", "spikes", "surf"],
		tier: "UU",
	},
	kabuto: {
		tier: "LC",
	},
	kabutops: {
		randomBattleMoves: ["brickbreak", "doubleedge", "hiddenpowerground", "rockslide", "surf", "swordsdance"],
		tier: "UU",
	},
	aerodactyl: {
		randomBattleMoves: ["doubleedge", "earthquake", "hiddenpowerflying", "rockslide", "substitute"],
		tier: "OU",
	},
	snorlax: {
		randomBattleMoves: ["bodyslam", "curse", "earthquake", "rest", "return", "selfdestruct", "shadowball", "sleeptalk"],
		tier: "OU",
	},
	articuno: {
		randomBattleMoves: ["healbell", "hiddenpowerfire", "icebeam", "protect", "rest", "roar", "sleeptalk", "toxic"],
		tier: "UUBL",
	},
	zapdos: {
		randomBattleMoves: ["agility", "batonpass", "hiddenpowerice", "substitute", "thunderbolt", "thunderwave", "toxic"],
		tier: "OU",
	},
	moltres: {
		randomBattleMoves: ["fireblast", "flamethrower", "hiddenpowergrass", "morningsun", "substitute", "toxic", "willowisp"],
		tier: "OU",
	},
	dratini: {
		tier: "LC",
	},
	dragonair: {
		tier: "NFE",
	},
	dragonite: {
		randomBattleMoves: ["doubleedge", "dragondance", "earthquake", "flamethrower", "healbell", "hiddenpowerflying", "icebeam", "substitute"],
		tier: "UUBL",
	},
	mewtwo: {
		randomBattleMoves: ["calmmind", "flamethrower", "icebeam", "psychic", "recover", "selfdestruct", "substitute", "thunderbolt"],
		tier: "Uber",
	},
	mew: {
		randomBattleMoves: ["calmmind", "explosion", "flamethrower", "icebeam", "psychic", "softboiled", "thunderbolt", "thunderwave", "transform"],
		tier: "Uber",
	},
	chikorita: {
		tier: "LC",
	},
	bayleef: {
		tier: "NFE",
	},
	meganium: {
		randomBattleMoves: ["bodyslam", "hiddenpowergrass", "leechseed", "synthesis", "toxic"],
		tier: "UU",
	},
	cyndaquil: {
		tier: "LC",
	},
	quilava: {
		tier: "NFE",
	},
	typhlosion: {
		randomBattleMoves: ["fireblast", "flamethrower", "focuspunch", "hiddenpowergrass", "hiddenpowerice", "substitute", "thunderpunch"],
		tier: "UUBL",
	},
	totodile: {
		tier: "LC",
	},
	croconaw: {
		tier: "NFE",
	},
	feraligatr: {
		randomBattleMoves: ["earthquake", "hiddenpowerflying", "hydropump", "rockslide", "swordsdance"],
		tier: "UU",
	},
	sentret: {
		tier: "LC",
	},
	furret: {
		randomBattleMoves: ["doubleedge", "quickattack", "return", "reversal", "shadowball", "substitute", "trick"],
		tier: "PU",
	},
	hoothoot: {
		tier: "LC",
	},
	noctowl: {
		randomBattleMoves: ["hypnosis", "psychic", "reflect", "toxic", "whirlwind"],
		tier: "PU",
	},
	ledyba: {
		tier: "LC",
	},
	ledian: {
		randomBattleMoves: ["agility", "batonpass", "lightscreen", "reflect", "silverwind", "swordsdance", "toxic"],
		tier: "PU",
	},
	spinarak: {
		tier: "LC",
	},
	ariados: {
		randomBattleMoves: ["agility", "batonpass", "signalbeam", "sludgebomb", "spiderweb", "toxic"],
		tier: "PU",
	},
	chinchou: {
		tier: "LC",
	},
	lanturn: {
		randomBattleMoves: ["confuseray", "icebeam", "rest", "sleeptalk", "surf", "thunderbolt", "thunderwave", "toxic"],
		tier: "UU",
	},
	togepi: {
		tier: "LC",
	},
	togetic: {
		randomBattleMoves: ["charm", "encore", "flamethrower", "seismictoss", "softboiled", "thunderwave", "toxic"],
		tier: "PU",
	},
	natu: {
		tier: "LC",
	},
	xatu: {
		randomBattleMoves: ["batonpass", "calmmind", "hiddenpowerfire", "psychic", "reflect", "wish"],
		tier: "UU",
	},
	mareep: {
		tier: "LC",
	},
	flaaffy: {
		tier: "NFE",
	},
	ampharos: {
		randomBattleMoves: ["firepunch", "healbell", "hiddenpowergrass", "hiddenpowerice", "thunderbolt", "toxic"],
		tier: "UU",
	},
	azurill: {
		tier: "LC",
	},
	marill: {
		tier: "NFE",
	},
	azumarill: {
		randomBattleMoves: ["brickbreak", "encore", "hiddenpowerghost", "hydropump", "return"],
		tier: "UU",
	},
	sudowoodo: {
		randomBattleMoves: ["brickbreak", "doubleedge", "earthquake", "explosion", "rockslide", "toxic"],
		tier: "NU",
	},
	hoppip: {
		tier: "LC",
	},
	skiploom: {
		tier: "NFE",
	},
	jumpluff: {
		randomBattleMoves: ["encore", "hiddenpowerflying", "leechseed", "sleeppowder", "substitute", "toxic"],
		tier: "UUBL",
	},
	aipom: {
		randomBattleMoves: ["batonpass", "doubleedge", "focuspunch", "shadowball", "substitute", "thunderwave"],
		tier: "PU",
	},
	sunkern: {
		tier: "LC",
	},
	sunflora: {
		randomBattleMoves: ["hiddenpowerfire", "leechseed", "razorleaf", "synthesis", "toxic"],
		tier: "PU",
	},
	yanma: {
		randomBattleMoves: ["hiddenpowerflying", "hypnosis", "reversal", "shadowball", "substitute"],
		tier: "PU",
	},
	wooper: {
		tier: "LC",
	},
	quagsire: {
		randomBattleMoves: ["counter", "curse", "earthquake", "hiddenpowerrock", "icebeam", "rest", "surf", "toxic"],
		tier: "UU",
	},
	murkrow: {
		randomBattleMoves: ["doubleedge", "drillpeck", "hiddenpowerfighting", "hiddenpowerground", "meanlook", "perishsong", "protect", "shadowball", "substitute"],
		tier: "NU",
	},
	misdreavus: {
		randomBattleMoves: ["calmmind", "hiddenpowerice", "meanlook", "perishsong", "protect", "substitute", "thunderbolt", "toxic"],
		tier: "UU",
	},
	unown: {
		randomBattleMoves: ["hiddenpowerpsychic"],
		tier: "PU",
	},
	wynaut: {
		tier: "Uber",
	},
	wobbuffet: {
		randomBattleMoves: ["counter", "destinybond", "encore", "mirrorcoat"],
		tier: "Uber",
	},
	girafarig: {
		randomBattleMoves: ["agility", "batonpass", "calmmind", "psychic", "substitute", "thunderbolt", "thunderwave", "wish"],
		tier: "UU",
	},
	pineco: {
		tier: "LC",
	},
	forretress: {
		randomBattleMoves: ["earthquake", "explosion", "hiddenpowerbug", "rapidspin", "spikes", "toxic"],
		tier: "OU",
	},
	dunsparce: {
		randomBattleMoves: ["bodyslam", "curse", "headbutt", "rest", "rockslide", "shadowball", "thunderwave"],
		tier: "PUBL",
	},
	gligar: {
		randomBattleMoves: ["earthquake", "hiddenpowerflying", "irontail", "quickattack", "rockslide", "substitute", "swordsdance"],
		tier: "UU",
	},
	snubbull: {
		tier: "LC",
	},
	granbull: {
		randomBattleMoves: ["bulkup", "earthquake", "healbell", "overheat", "rest", "return", "shadowball", "thunderwave"],
		tier: "UU",
	},
	qwilfish: {
		randomBattleMoves: ["destinybond", "hydropump", "selfdestruct", "shadowball", "sludgebomb", "spikes", "swordsdance"],
		tier: "UU",
	},
	shuckle: {
		randomBattleMoves: ["encore", "protect", "rest", "toxic", "wrap"],
		tier: "PU",
	},
	heracross: {
		randomBattleMoves: ["brickbreak", "focuspunch", "megahorn", "rest", "rockslide", "sleeptalk", "substitute", "swordsdance"],
		tier: "OU",
	},
	sneasel: {
		randomBattleMoves: ["brickbreak", "doubleedge", "hiddenpowerflying", "shadowball", "substitute", "swordsdance"],
		tier: "UU",
	},
	teddiursa: {
		tier: "LC",
	},
	ursaring: {
		randomBattleMoves: ["earthquake", "focuspunch", "hiddenpowerghost", "return", "swordsdance"],
		tier: "UUBL",
	},
	slugma: {
		tier: "LC",
	},
	magcargo: {
		randomBattleMoves: ["fireblast", "hiddenpowergrass", "rest", "sleeptalk", "toxic", "yawn"],
		tier: "PU",
	},
	swinub: {
		tier: "LC",
	},
	piloswine: {
		randomBattleMoves: ["doubleedge", "earthquake", "icebeam", "protect", "rockslide", "toxic"],
		tier: "PU",
	},
	corsola: {
		randomBattleMoves: ["calmmind", "confuseray", "icebeam", "recover", "surf", "toxic"],
		tier: "PU",
	},
	remoraid: {
		tier: "LC",
	},
	octillery: {
		randomBattleMoves: ["fireblast", "hiddenpowergrass", "icebeam", "rockblast", "surf", "thunderwave"],
		tier: "NU",
	},
	delibird: {
		randomBattleMoves: ["aerialace", "focuspunch", "hiddenpowerground", "icebeam", "quickattack"],
		tier: "PU",
	},
	mantine: {
		randomBattleMoves: ["haze", "hiddenpowergrass", "icebeam", "raindance", "rest", "sleeptalk", "surf", "toxic"],
		tier: "UU",
	},
	skarmory: {
		randomBattleMoves: ["drillpeck", "hiddenpowerground", "protect", "rest", "roar", "sleeptalk", "spikes", "toxic"],
		tier: "OU",
	},
	houndour: {
		tier: "LC",
	},
	houndoom: {
		randomBattleMoves: ["crunch", "fireblast", "flamethrower", "hiddenpowergrass", "pursuit", "willowisp"],
		tier: "UUBL",
	},
	phanpy: {
		tier: "LC",
	},
	donphan: {
		randomBattleMoves: ["earthquake", "hiddenpowerbug", "rapidspin", "rest", "roar", "rockslide", "sleeptalk", "toxic"],
		tier: "UUBL",
	},
	stantler: {
		randomBattleMoves: ["earthquake", "hypnosis", "return", "shadowball", "thunderbolt"],
		tier: "UU",
	},
	smeargle: {
		randomBattleMoves: ["encore", "explosion", "spikes", "spore"],
		tier: "UUBL",
	},
	miltank: {
		randomBattleMoves: ["bodyslam", "curse", "earthquake", "healbell", "milkdrink", "toxic"],
		tier: "UUBL",
	},
	raikou: {
		randomBattleMoves: ["calmmind", "crunch", "hiddenpowergrass", "hiddenpowerice", "rest", "sleeptalk", "substitute", "thunderbolt"],
		tier: "UUBL",
	},
	entei: {
		randomBattleMoves: ["bodyslam", "calmmind", "fireblast", "flamethrower", "hiddenpowergrass", "hiddenpowerice", "solarbeam", "substitute", "sunnyday"],
		tier: "UUBL",
	},
	suicune: {
		randomBattleMoves: ["calmmind", "icebeam", "rest", "sleeptalk", "substitute", "surf", "toxic"],
		tier: "OU",
	},
	larvitar: {
		tier: "LC",
	},
	pupitar: {
		tier: "NU",
	},
	tyranitar: {
		randomBattleMoves: ["dragondance", "earthquake", "fireblast", "focuspunch", "hiddenpowerbug", "icebeam", "pursuit", "rockslide", "substitute"],
		tier: "OU",
	},
	lugia: {
		randomBattleMoves: ["aeroblast", "calmmind", "earthquake", "icebeam", "recover", "substitute", "thunderbolt", "toxic"],
		tier: "Uber",
	},
	hooh: {
		randomBattleMoves: ["calmmind", "earthquake", "recover", "sacredfire", "substitute", "thunderbolt", "toxic"],
		tier: "Uber",
	},
	celebi: {
		randomBattleMoves: ["batonpass", "calmmind", "healbell", "hiddenpowergrass", "leechseed", "psychic", "recover"],
		tier: "OU",
	},
	treecko: {
		tier: "LC",
	},
	grovyle: {
		tier: "NFE",
	},
	sceptile: {
		randomBattleMoves: ["focuspunch", "hiddenpowerice", "leafblade", "leechseed", "substitute", "thunderpunch"],
		tier: "UUBL",
	},
	torchic: {
		tier: "LC",
	},
	combusken: {
		tier: "NFE",
	},
	blaziken: {
		randomBattleMoves: ["endure", "fireblast", "hiddenpowerice", "reversal", "rockslide", "skyuppercut", "swordsdance", "thunderpunch"],
		tier: "UUBL",
	},
	mudkip: {
		tier: "LC",
	},
	marshtomp: {
		tier: "NFE",
	},
	swampert: {
		randomBattleMoves: ["earthquake", "hydropump", "icebeam", "protect", "rest", "rockslide", "sleeptalk", "surf", "toxic"],
		tier: "OU",
	},
	poochyena: {
		tier: "LC",
	},
	mightyena: {
		randomBattleMoves: ["crunch", "doubleedge", "healbell", "hiddenpowerfighting", "protect", "shadowball", "toxic"],
		tier: "PU",
	},
	zigzagoon: {
		tier: "LC",
	},
	linoone: {
		randomBattleMoves: ["bellydrum", "extremespeed", "flail", "hiddenpowerground", "shadowball", "substitute"],
		tier: "UU",
	},
	wurmple: {
		tier: "LC",
	},
	silcoon: {
		tier: "NFE",
	},
	beautifly: {
		randomBattleMoves: ["hiddenpowerbug", "hiddenpowerflying", "morningsun", "stunspore", "substitute", "toxic"],
		tier: "PU",
	},
	cascoon: {
		tier: "NFE",
	},
	dustox: {
		randomBattleMoves: ["hiddenpowerground", "lightscreen", "moonlight", "sludgebomb", "toxic", "whirlwind"],
		tier: "PU",
	},
	lotad: {
		tier: "LC",
	},
	lombre: {
		tier: "NFE",
	},
	ludicolo: {
		randomBattleMoves: ["hiddenpowergrass", "icebeam", "leechseed", "raindance", "substitute", "surf"],
		tier: "UUBL",
	},
	seedot: {
		tier: "LC",
	},
	nuzleaf: {
		tier: "NFE",
	},
	shiftry: {
		randomBattleMoves: ["brickbreak", "explosion", "shadowball", "swordsdance"],
		tier: "UU",
	},
	taillow: {
		tier: "LC",
	},
	swellow: {
		randomBattleMoves: ["aerialace", "doubleedge", "hiddenpowerfighting", "hiddenpowerground", "quickattack", "return"],
		tier: "UUBL",
	},
	wingull: {
		tier: "LC",
	},
	pelipper: {
		randomBattleMoves: ["icebeam", "protect", "rest", "sleeptalk", "surf", "toxic"],
		tier: "NU",
	},
	ralts: {
		tier: "LC",
	},
	kirlia: {
		tier: "NFE",
	},
	gardevoir: {
		randomBattleMoves: ["calmmind", "firepunch", "hypnosis", "psychic", "substitute", "thunderbolt", "willowisp"],
		tier: "UUBL",
	},
	surskit: {
		tier: "LC",
	},
	masquerain: {
		randomBattleMoves: ["hydropump", "icebeam", "stunspore", "substitute", "toxic"],
		tier: "PU",
	},
	shroomish: {
		tier: "LC",
	},
	breloom: {
		randomBattleMoves: ["focuspunch", "hiddenpowerghost", "hiddenpowerrock", "leechseed", "machpunch", "skyuppercut", "spore", "substitute", "swordsdance"],
		tier: "OU",
	},
	slakoth: {
		tier: "LC",
	},
	vigoroth: {
		randomBattleMoves: ["brickbreak", "bulkup", "earthquake", "return", "shadowball", "slackoff"],
		tier: "NU",
	},
	slaking: {
		randomBattleMoves: ["doubleedge", "earthquake", "focuspunch", "return", "shadowball"],
		tier: "UUBL",
	},
	nincada: {
		tier: "LC",
	},
	ninjask: {
		randomBattleMoves: ["aerialace", "batonpass", "hiddenpowerrock", "protect", "silverwind", "substitute", "swordsdance"],
		tier: "UU",
	},
	shedinja: {
		randomBattleMoves: ["agility", "batonpass", "hiddenpowerground", "shadowball", "silverwind", "toxic"],
		tier: "PU",
	},
	whismur: {
		tier: "LC",
	},
	loudred: {
		tier: "NFE",
	},
	exploud: {
		randomBattleMoves: ["earthquake", "flamethrower", "icebeam", "overheat", "return", "shadowball", "substitute"],
		tier: "UU",
	},
	makuhita: {
		tier: "LC",
	},
	hariyama: {
		randomBattleMoves: ["bulkup", "crosschop", "fakeout", "hiddenpowerghost", "rest", "rockslide", "sleeptalk"],
		tier: "UUBL",
	},
	nosepass: {
		randomBattleMoves: ["earthquake", "explosion", "rockslide", "thunderbolt", "thunderwave", "toxic"],
		tier: "PU",
	},
	skitty: {
		tier: "LC",
	},
	delcatty: {
		randomBattleMoves: ["batonpass", "doubleedge", "healbell", "thunderwave", "wish"],
		tier: "PU",
	},
	sableye: {
		randomBattleMoves: ["knockoff", "recover", "seismictoss", "shadowball", "toxic"],
		tier: "NU",
	},
	mawile: {
		randomBattleMoves: ["batonpass", "brickbreak", "focuspunch", "hiddenpowersteel", "rockslide", "substitute", "swordsdance", "toxic"],
		tier: "PU",
	},
	aron: {
		tier: "LC",
	},
	lairon: {
		tier: "NFE",
	},
	aggron: {
		randomBattleMoves: ["counter", "doubleedge", "earthquake", "focuspunch", "irontail", "rockslide", "substitute", "thunderwave", "toxic"],
		tier: "UU",
	},
	meditite: {
		tier: "LC",
	},
	medicham: {
		randomBattleMoves: ["brickbreak", "bulkup", "fakeout", "recover", "rockslide", "shadowball", "substitute"],
		tier: "UUBL",
	},
	electrike: {
		tier: "LC",
	},
	manectric: {
		randomBattleMoves: ["crunch", "hiddenpowergrass", "hiddenpowerice", "substitute", "thunderbolt", "thunderwave"],
		tier: "UU",
	},
	plusle: {
		randomBattleMoves: ["agility", "batonpass", "encore", "hiddenpowergrass", "substitute", "thunderbolt", "toxic"],
		tier: "NU",
	},
	minun: {
		randomBattleMoves: ["batonpass", "encore", "hiddenpowerice", "lightscreen", "substitute", "thunderbolt", "wish"],
		tier: "PU",
	},
	volbeat: {
		randomBattleMoves: ["batonpass", "icepunch", "tailglow", "thunderbolt"],
		tier: "PU",
	},
	illumise: {
		randomBattleMoves: ["batonpass", "encore", "icepunch", "substitute", "thunderwave", "wish"],
		tier: "PU",
	},
	roselia: {
		randomBattleMoves: ["aromatherapy", "gigadrain", "hiddenpowerfire", "spikes", "stunspore", "synthesis"],
		tier: "NU",
	},
	gulpin: {
		tier: "LC",
	},
	swalot: {
		randomBattleMoves: ["encore", "explosion", "hiddenpowerground", "icebeam", "sludgebomb", "toxic", "yawn"],
		tier: "PU",
	},
	carvanha: {
		tier: "LC",
	},
	sharpedo: {
		randomBattleMoves: ["crunch", "earthquake", "endure", "hiddenpowerflying", "hydropump", "icebeam", "return"],
		tier: "UU",
	},
	wailmer: {
		tier: "LC",
	},
	wailord: {
		randomBattleMoves: ["hiddenpowergrass", "icebeam", "rest", "selfdestruct", "sleeptalk", "surf", "toxic"],
		tier: "NU",
	},
	numel: {
		tier: "LC",
	},
	camerupt: {
		randomBattleMoves: ["earthquake", "explosion", "fireblast", "rest", "rockslide", "sleeptalk", "toxic"],
		tier: "UU",
	},
	torkoal: {
		randomBattleMoves: ["explosion", "fireblast", "flamethrower", "hiddenpowergrass", "rest", "toxic", "yawn"],
		tier: "NU",
	},
	spoink: {
		tier: "LC",
	},
	grumpig: {
		randomBattleMoves: ["calmmind", "firepunch", "icywind", "psychic", "substitute", "taunt"],
		tier: "UU",
	},
	spinda: {
		randomBattleMoves: ["bodyslam", "encore", "focuspunch", "shadowball", "substitute", "teeterdance", "toxic"],
		tier: "PU",
	},
	trapinch: {
		tier: "LC",
	},
	vibrava: {
		tier: "NFE",
	},
	flygon: {
		randomBattleMoves: ["dragonclaw", "earthquake", "fireblast", "hiddenpowerbug", "rockslide", "substitute", "toxic"],
		tier: "OU",
	},
	cacnea: {
		tier: "LC",
	},
	cacturne: {
		randomBattleMoves: ["focuspunch", "hiddenpowerdark", "leechseed", "needlearm", "spikes", "substitute", "thunderpunch"],
		tier: "NU",
	},
	swablu: {
		tier: "LC",
	},
	altaria: {
		randomBattleMoves: ["dragonclaw", "dragondance", "earthquake", "fireblast", "flamethrower", "haze", "hiddenpowerflying", "rest", "toxic"],
		tier: "UU",
	},
	zangoose: {
		randomBattleMoves: ["brickbreak", "quickattack", "return", "shadowball", "swordsdance"],
		tier: "UUBL",
	},
	seviper: {
		randomBattleMoves: ["crunch", "doubleedge", "earthquake", "flamethrower", "hiddenpowergrass", "sludgebomb"],
		tier: "PU",
	},
	lunatone: {
		randomBattleMoves: ["batonpass", "calmmind", "explosion", "hypnosis", "icebeam", "psychic"],
		tier: "UU",
	},
	solrock: {
		randomBattleMoves: ["earthquake", "explosion", "overheat", "reflect", "rockslide", "shadowball"],
		tier: "UU",
	},
	barboach: {
		tier: "LC",
	},
	whiscash: {
		randomBattleMoves: ["earthquake", "hiddenpowerbug", "icebeam", "rest", "rockslide", "sleeptalk", "spark", "surf", "toxic"],
		tier: "NU",
	},
	corphish: {
		tier: "LC",
	},
	crawdaunt: {
		randomBattleMoves: ["brickbreak", "crunch", "doubleedge", "hiddenpowerghost", "icebeam", "surf"],
		tier: "NU",
	},
	baltoy: {
		tier: "LC",
	},
	claydol: {
		randomBattleMoves: ["earthquake", "explosion", "icebeam", "psychic", "rapidspin", "toxic"],
		tier: "OU",
	},
	lileep: {
		tier: "LC",
	},
	cradily: {
		randomBattleMoves: ["barrier", "earthquake", "hiddenpowergrass", "mirrorcoat", "recover", "rockslide", "toxic"],
		tier: "UU",
	},
	anorith: {
		tier: "LC",
	},
	armaldo: {
		randomBattleMoves: ["doubleedge", "earthquake", "hiddenpowerbug", "rockslide", "swordsdance"],
		tier: "UUBL",
	},
	feebas: {
		tier: "LC",
	},
	milotic: {
		randomBattleMoves: ["icebeam", "mirrorcoat", "recover", "surf", "toxic"],
		tier: "OU",
	},
	castform: {
		randomBattleMoves: ["flamethrower", "icebeam", "substitute", "thunderbolt", "thunderwave"],
		tier: "PU",
	},
	castformsunny: {
		tier: "PU",
	},
	castformrainy: {
		tier: "PU",
	},
	castformsnowy: {
		tier: "PU",
	},
	kecleon: {
		randomBattleMoves: ["brickbreak", "return", "shadowball", "thunderwave", "trick"],
		tier: "NU",
	},
	shuppet: {
		tier: "LC",
	},
	banette: {
		randomBattleMoves: ["destinybond", "endure", "hiddenpowerfighting", "knockoff", "shadowball", "willowisp"],
		tier: "UU",
	},
	duskull: {
		tier: "LC",
	},
	dusclops: {
		randomBattleMoves: ["focuspunch", "icebeam", "painsplit", "rest", "shadowball", "sleeptalk", "substitute", "willowisp"],
		tier: "UUBL",
	},
	tropius: {
		randomBattleMoves: ["hiddenpowerfire", "solarbeam", "sunnyday", "synthesis"],
		tier: "PU",
	},
	chimecho: {
		randomBattleMoves: ["calmmind", "healbell", "hiddenpowerfire", "lightscreen", "psychic", "reflect", "toxic", "yawn"],
		tier: "NU",
	},
	absol: {
		randomBattleMoves: ["batonpass", "hiddenpowerfighting", "quickattack", "shadowball", "swordsdance"],
		tier: "UU",
	},
	snorunt: {
		tier: "LC",
	},
	glalie: {
		randomBattleMoves: ["earthquake", "explosion", "icebeam", "spikes", "toxic"],
		tier: "NU",
	},
	spheal: {
		tier: "LC",
	},
	sealeo: {
		tier: "NFE",
	},
	walrein: {
		randomBattleMoves: ["encore", "hiddenpowergrass", "icebeam", "rest", "sleeptalk", "surf", "toxic"],
		tier: "UU",
	},
	clamperl: {
		tier: "LC",
	},
	huntail: {
		randomBattleMoves: ["doubleedge", "hiddenpowergrass", "hydropump", "icebeam", "raindance", "surf"],
		tier: "NU",
	},
	gorebyss: {
		randomBattleMoves: ["hiddenpowerelectric", "hiddenpowergrass", "hydropump", "icebeam", "raindance", "surf"],
		tier: "UU",
	},
	relicanth: {
		randomBattleMoves: ["doubleedge", "earthquake", "hiddenpowerflying", "rest", "rockslide", "sleeptalk", "toxic"],
		tier: "NU",
	},
	luvdisc: {
		randomBattleMoves: ["icebeam", "protect", "substitute", "surf", "sweetkiss", "toxic"],
		tier: "PU",
	},
	bagon: {
		tier: "LC",
	},
	shelgon: {
		tier: "NFE",
	},
	salamence: {
		randomBattleMoves: ["brickbreak", "dragondance", "earthquake", "fireblast", "hiddenpowerflying", "rockslide"],
		tier: "OU",
	},
	beldum: {
		tier: "LC",
	},
	metang: {
		tier: "NU",
	},
	metagross: {
		randomBattleMoves: ["agility", "earthquake", "explosion", "meteormash", "psychic", "rockslide"],
		tier: "OU",
	},
	regirock: {
		randomBattleMoves: ["curse", "earthquake", "explosion", "rest", "rockslide", "superpower", "thunderwave"],
		tier: "UUBL",
	},
	regice: {
		randomBattleMoves: ["explosion", "icebeam", "rest", "sleeptalk", "thunderbolt", "thunderwave", "toxic"],
		tier: "UUBL",
	},
	registeel: {
		randomBattleMoves: ["rest", "seismictoss", "sleeptalk", "toxic"],
		tier: "UUBL",
	},
	latias: {
		randomBattleMoves: ["calmmind", "dragonclaw", "hiddenpowerfire", "recover", "refresh", "toxic"],
		tier: "Uber",
	},
	latios: {
		randomBattleMoves: ["calmmind", "dragonclaw", "hiddenpowerfire", "psychic", "recover", "refresh", "thunderbolt"],
		tier: "Uber",
	},
	kyogre: {
		randomBattleMoves: ["calmmind", "icebeam", "rest", "sleeptalk", "surf", "thunder"],
		tier: "Uber",
	},
	groudon: {
		randomBattleMoves: ["earthquake", "hiddenpowerbug", "overheat", "rockslide", "substitute", "swordsdance", "thunderwave"],
		tier: "Uber",
	},
	rayquaza: {
		randomBattleMoves: ["dragondance", "earthquake", "extremespeed", "hiddenpowerflying", "overheat", "rockslide"],
		tier: "Uber",
	},
	jirachi: {
		randomBattleMoves: ["bodyslam", "calmmind", "firepunch", "icepunch", "protect", "psychic", "substitute", "thunderbolt", "wish"],
		tier: "OU",
	},
	deoxys: {
		randomBattleMoves: ["extremespeed", "firepunch", "icebeam", "psychoboost", "shadowball", "superpower"],
		tier: "Uber",
	},
	deoxysattack: {
		randomBattleMoves: ["extremespeed", "firepunch", "psychoboost", "shadowball", "superpower"],
		tier: "Uber",
	},
	deoxysdefense: {
		randomBattleMoves: ["nightshade", "recover", "spikes", "taunt", "toxic"],
		tier: "Uber",
	},
	deoxysspeed: {
		randomBattleMoves: ["calmmind", "icebeam", "psychic", "recover", "spikes", "taunt", "toxic"],
		tier: "Uber",
	},
};
